import Image from "next/image";
import Link from "next/link";
import React from "react";

const BreadCrumb = ({ data }) => {
  const { data: urls } = data?.BreadCrumb || {};

  return (
    <div className="flex items-center gap-3">
      {urls?.map((url, index) => {
        return (
          <Link
            key={url.url}
            href={url.url}
            title={url.title}
            prefetch={false}
            className="flex items-center gap-2 text-sm font-normal leading-normal text-opacity-50 text-themeBreadcrumColor -tracking--size-3"
          >
            {index > 0 && (
              <Image
                src="/icons/Ellipsex.svg"
                alt="ellipsex"
                width={4}
                height={4}
              />
            )}
            <span
              className={`${
                index !== urls.length - 1
                  ? "text-blueOcean-200"
                  : "text-dark-main"
              } `}
            >
              {url.name}
            </span>
          </Link>
        );
      })}
    </div>
  );
};

export default BreadCrumb;
